'use client';

import { services } from '@/constants';
import { cn } from '@/lib/utils';
import { PathEnum } from '@/types/enums';
import { ArrowUpRight, Tally2, X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import H4 from '../ui/H4';
import H5 from '../ui/H5';
import Link from '../ui/Link';

export default function MobileHeaderMenu() {
    const t = useTranslations();

    const [isMobileMenuOpened, setIsMobileMenuOpened] = useState<boolean>(false);

    const toggleMenu = () => setIsMobileMenuOpened((prev) => !prev);

    useEffect(() => {
        if (isMobileMenuOpened) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMobileMenuOpened]);

    return (
        <>
            <Tally2
                strokeWidth={1.5}
                width={44}
                height={56}
                className="rotate-90 hidden sm:block lg:hidden text-white mt-5 ml-6 max-sm:ml-1"
                onClick={toggleMenu}
            />
            <Tally2
                strokeWidth={1.5}
                width={32}
                height={44}
                className="rotate-90 sm:hidden max-sm:block text-white mt-4 ml-6 max-sm:ml-1"
                onClick={toggleMenu}
            />
            <div
                className={cn(
                    'fixed w-screen h-screen top-0 left-0 bg-white-bg shadow-m backdrop-blur-md backdrop-brightness-90 p-10 sm:p-[60px] hidden max-lg:flex flex-col gap-5 transition-all translate-x-[100vw] overflow-y-auto z-30',
                    isMobileMenuOpened && 'translate-x-0',
                )}
            >
                <div className="flex justify-between items-center">
                    <Link className="hover:underline" href={PathEnum.Home} onClick={toggleMenu}>
                        <H4 className="max-lg:text-h4 font-medium">{t('Header.home')}</H4>
                    </Link>
                    <X strokeWidth={1} onClick={toggleMenu} />
                </div>
                <hr className="container mx-auto h-[1px] w-full bg-white" />
                <Link href={PathEnum.Services} className="text-left" onClick={toggleMenu}>
                    <H4 className="max-lg:text-h4 font-medium text-dark-grey">
                        {t('Header.services')}
                    </H4>
                </Link>
                <div className="flex flex-col gap-2">
                    {services.map(({ name, href }, index) => (
                        <Link
                            href={href}
                            className="hover:underline flex justify-between items-center gap-4"
                            key={index}
                            onClick={toggleMenu}
                        >
                            <>
                                <H5>{t(`Services.${name}`)}</H5>
                                <ArrowUpRight strokeWidth={1} />
                            </>
                        </Link>
                    ))}
                </div>
                <hr className="container mx-auto h-[1px] w-full bg-white" />
                <Link className="hover:underline" href={PathEnum.About} onClick={toggleMenu}>
                    <H4 className="max-lg:text-h4 font-medium">{t('Footer.about')}</H4>
                </Link>
                <Link className="hover:underline" href={PathEnum.Partners} onClick={toggleMenu}>
                    <H4 className="max-lg:text-h4 font-medium">{t('Footer.partners')}</H4>
                </Link>
            </div>
        </>
    );
}
